import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Bugfender } from '@bugfender/sdk';
import { isFollowrStudioHostname } from 'components/ui/utils/constant';
import './styles/globals.css';

if (typeof window !== 'undefined' && isFollowrStudioHostname(window.location.hostname)) {
    document.documentElement.style.setProperty('--primary-color', '#8b5cf6');
}

Bugfender.init({
    appKey: 'i8RUuNDyEEvArKYUYxGPaPg9su6COOxL',
    // apiURL: process.env.REACT_APP_API_HOST,
    // baseURL: process.env.REACT_APP_BASE_URL,
    overrideConsoleMethods: false,
    // printToConsole: true,
    registerErrorHandler: false,
    logBrowserEvents: false,
    logUIEvents: false,
    // version: '',
    // build: '',
});

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
    <App />
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
